function getLargestImage(data): any {
	if (data && typeof data === 'object' && !Array.isArray(data)) {
		const imgData = data.png || data.jpg;
		if (imgData) {
			return imgData[Math.max(...Object.keys(imgData).filter(Number).map(Number))] || null;
		}
		return data.svg?.svg || null;
	}

	return null;
}

export default getLargestImage;
